/**
 * Defines temporary / short-lived toggles used to control whether an in-development feature
 * is available in the environment.
 * The values for these are currently expected to come from environment variables configured in
 * the build environment. These can be defined in
 * - local development: local environment/.env files
 * - deployment builds: the amplify configuration (amplify.yml)
 *
 * TODO: One day we'd like these to be more dynamic and sourced from an API instead, so that
 * code changes & releases are not needed to enable a feature once ready & tested.
 */
export type ReleaseToggles = {
  adminPermissionsTogglesEnabled: boolean;
  ownFleetEnabled: boolean;
  /**
   * Release toggle to specify whether the map/geospatial layer handler is enabled.
   */
  mapLayerHandlerEnabled: boolean;
  searchV2Enabled: boolean;

  drawingColourEnabled: boolean;
  vesselListColourEnabled: boolean;
  lastLoginEnabled: boolean;
};

export const getReleaseToggles = (): ReleaseToggles => ({
  adminPermissionsTogglesEnabled:
    process.env.REACT_APP_PERMISSIONS_TOGGLE_ADMINISTRATION_ENABLED === 'true',
  mapLayerHandlerEnabled:
    process.env.REACT_APP_MAP_LAYER_HANDLER_ENABLED === 'true',
  searchV2Enabled: process.env.REACT_APP_SEARCH_V2_ENABLED === 'true',
  ownFleetEnabled: process.env.REACT_APP_OWN_FLEET_ENABLED === 'true',
  drawingColourEnabled: process.env.REACT_APP_DRAWING_COLOUR_ENABLED === 'true',
  vesselListColourEnabled:
    process.env.REACT_APP_VESSEL_LIST_COLOUR_ENABLED === 'true',
  lastLoginEnabled: process.env.REACT_APP_LAST_LOGIN_ENABLED === 'true',
});
